import api from "../../utils/api";
import { apiPath } from "../../utils/apiPath";
import moment from "moment-timezone";
import { formatTime, formatApiDateTime } from "../../utils/common.js";


export async function fetchShiftGroupApi(payload) {
  return await api.get(`${apiPath.API_URL}${apiPath.shiftGroup.list}`, {
    params: payload,
  });
}

export const getShiftGroupByIdApi = async (payload) => {
  return await api.get(
    `${apiPath.API_URL}${apiPath.shiftGroup.getShiftGroupById}/${payload.ShiftGroupCode}`
    
  )
} 

export async function updateShiftGroupApi(payload) {
  return await api.put(
    `${apiPath.API_URL}${apiPath.shiftGroup.update}/${payload.ShiftGroupCode}`,
    {
      ShiftGroupCode: payload.ShiftGroupCode,
      ShiftGroupName: payload.shiftGroupName,
      Rotation: payload.Rotation ? 1 : 0,
      Status: payload.Status ? 1 : 0,
    },
  );
}

export async function createShiftGroupApi(payload) {
  return await api.post(`${apiPath.API_URL}${apiPath.shiftGroup.create}`,
     {
    
    // ShiftGroupCode: payload.ShiftGroupCode,

    ShiftGroupName: payload.ShiftGroupName,
    Rotation: payload.Rotation ? 1 : 0,
    Status: payload.Status ? 1 : 0,
  });
}

export async function checkDeleteShiftGroupApi(payload) {
  return await api.get(
    `${apiPath.API_URL}${apiPath.shiftGroup.delete_shift}/${payload.ShiftGroupCode}`,
  );
}

export async function deleteShiftGroupApi(payload) {
  return await api.delete(
    `${apiPath.API_URL}${apiPath.shiftGroup.delete}/${payload.ShiftGroupCode}`,
    // {
    //     params : {
    //     ShiftGroupCode: payload.ShiftGroupCode,
    //     }
    // }
  );
}

export const shiftListApi = async (payload) => {
  return await api.get(`${apiPath.API_URL}${apiPath.shiftGroup.shiftlist}`, {
    params: payload,
  });
};
export const createShiftApi = async (payload) => {
  return await api.post(`${apiPath.API_URL}${apiPath.shiftGroup.create_list}`, {
    ShiftGroupCode: payload.ShiftGroupCode,
    ShiftName: payload.ShiftName,
    ShortName: payload.ShortName,
    ShiftNo: Number(payload.ShiftNo),
    Status: payload.Status ? 1 : 0,

    InTime: formatApiDateTime(payload.InTime),
    OutTime: formatApiDateTime(payload.OutTime),

    BeginningIn: formatApiDateTime(payload.BeginningIn),
    BeginningInNextDay: payload.BeginningInNextDay ? 1 : 0,

    BeginningOut: formatApiDateTime(payload.BeginningOut),
    BeginningOutNextDay: payload.BeginningOutNextDay ? 1 : 0,

    EndingIn: formatApiDateTime(payload.EndingIn),
    EndingInNextDay: payload.EndingInNextDay ? 1 : 0,
    EndingOut: formatApiDateTime(payload.EndingOut),
    EndingOutNextDay: payload.EndingOutNextDay ? 1 : 0,

    WorkingMins: Number(payload.WorkingMins),
    WorkingHours: formatTime(payload.WorkingHours),

    HalfDayWorkingMins: Number(payload.HalfDayWorkingMins),
    HalfDayWorkingHours: formatTime(payload.HalfDayWorkingHours),

    LunchBreakMins: Number(payload.LunchBreakMins),
    LunchBreakHours: formatTime(payload.LunchBreakHours),
  });
};

export const getShiftByIdApi = async (payload) => {
  return await api.get(
    `${apiPath.API_URL}${apiPath.shiftGroup.getShiftById}/${payload.ShiftCode}`,
  );
};

export const updateShiftApi = async (payload) => {
  return await api.put(
    `${apiPath.API_URL}${apiPath.shiftGroup.updateShift}/${payload.ShiftCode}`,
    {
      ShiftGroupCode: payload.ShiftGroupCode,
      ShiftName: payload.ShiftName,
      ShortName: payload.ShortName,
      ShiftNo: Number(payload.ShiftNo),
      Status: payload.Status ? 1: 0,
      InTime: payload.InTime,
      OutTime: payload.OutTime,
      BeginningIn: payload.BeginningIn,
      BeginningOut: payload.BeginningOut,
      EndingIn: payload.EndingIn,
      EndingOut: payload.EndingOut,
      WorkingMins: Number(payload.WorkingMins),
      HalfDayWorkingMins: Number(payload.HalfDayWorkingMins),
      WorkingHours: formatTime(payload.WorkingHours),
      HalfDayWorkingHours: formatTime(payload.HalfDayWorkingHours),
      LunchBreakMins: Number(payload.LunchBreakMins),
      LunchBreakHours: formatTime(payload.LunchBreakHours),

    },
  );
};

export async function checkDeleteShiftApi(payload) {
  return await api.get(
    `${apiPath.API_URL}${apiPath.shiftGroup.delete_list_message}/${payload.ShiftCode}`,
  );
}
export const deleteShiftApi = async (payload) => {
  return await api.delete(
    `${apiPath.API_URL}${apiPath.shiftGroup.delete_list}/${payload.ShiftCode}`,

    // {
    //     data: {
    //         ShiftCode: payload.ShiftCode,

    //     },
    // }
  );
};
